import { LanguageFileApi } from '@app/api';
import { MLanguageFiles } from '@elte/translate-backend/interface/lang_file';
import { IObservableValue, observable } from 'mobx';

export class LanguageFileModel {
    private api: LanguageFileApi;

    constructor() {
        this.api = new LanguageFileApi();
    }

    dataLanguage: IObservableValue<MLanguageFiles.TResponseLanguageFiles> = observable.box(null, { deep: false });

    getLanguageFiles(sourceId: string, targetId: string) {
        return this.api.find({ source: sourceId, target: targetId }).then((value) => {
            this.dataLanguage.set(value[0]);
            return value[0];
        });
    }

    /**
     * @description Zapisuje plik (tymczasowy) osoby tłumaczącej
     */
    saveFileTemp(data: MLanguageFiles.TLanguageFile, targetLanguage: string) {
        return this.api.create(
            {
                main: null,
                target: data
            },
            { accept: false, files: { source: '', target: targetLanguage } }
        );
    }

    /**
     * @description Zapisuje plik (tymczasowy) osoby tłumaczącej
     */
    // saveFileAccept(data: MLanguageFiles.TLanguageFile, targetLanguage: string) {
    //     return this.api.create({
    //         main: null,
    //         target: data
    //     }, {accept: true, files: {source: "", target: targetLanguage}})
    // }
}
